import React from 'react'
import { Platform } from 'react-native'

import { FormattedMessage } from 'react-intl'
import { useLink } from 'solito/link'

import QuestionIcon from 'app/assets/icons/auth/question-mark.svg'
import Box from 'app/components/base/Box'
import IconButton from 'app/components/base/IconButton'
import Link from 'app/components/base/Link'
import Stack from 'app/components/base/Stack'
import Text from 'app/components/base/Text'
import Tooltip from 'app/components/base/Tooltip'
import useAppStore from 'app/store/app.store'

import GradientButton from './components/GradientButton'
import QuestionTooltipContent from './components/QuestionTooltipContent'

const SignUpFeature = () => {
  const isTablet = useAppStore((state) => state.isTablet)

  const personalAccountLink = useLink({
    href: '/sign-up/personal-account'
  })
  const businessAccountLink = useLink({
    href: '/sign-up/business-account'
  })

  return (
    <Stack direction="column" sx={{ ...(!isTablet && { flex: 1 }) }}>
      <Text variant="h2" sx={{ textAlign: 'center', mb: 2 }}>
        <FormattedMessage defaultMessage="Sign up" />
      </Text>

      <Text
        variant="body1"
        sx={{ textAlign: 'center', mb: 3, color: 'text.third' }}
      >
        <FormattedMessage defaultMessage="Create a free account" />
      </Text>

      <Box sx={{ flex: 1 }}>
        <GradientButton {...personalAccountLink}>
          <FormattedMessage defaultMessage="Personal Account" />
        </GradientButton>

        <GradientButton {...businessAccountLink}>
          <FormattedMessage defaultMessage="Business Account" />
        </GradientButton>
      </Box>

      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        sx={{ mb: 3 }}
      >
        <Tooltip
          content={<QuestionTooltipContent />}
          {...Platform.select({ android: { topAdjustment: -18 } })}
          isCloseButton
        >
          <IconButton>
            <QuestionIcon />
          </IconButton>
        </Tooltip>

        <Text variant="body2" sx={{ color: 'text.third' }}>
          <FormattedMessage defaultMessage="What is a business account" />
        </Text>
      </Stack>

      <Stack
        direction="row"
        sx={{
          textAlign: 'center',
          justifyContent: 'center'
        }}
        spacing={0.5}
      >
        <Text variant="body2" sx={{ color: 'text.third' }}>
          <FormattedMessage defaultMessage="Already have an account?" />
        </Text>

        <Link
          href="/sign-in"
          variant="body2"
          sx={{
            fontWeight: 500,
            color: 'text.primary'
          }}
        >
          <FormattedMessage defaultMessage="Sign in" />
        </Link>
      </Stack>
    </Stack>
  )
}

export default SignUpFeature
